import type { MarkType } from "prosemirror-model";
import type { EditorState } from "prosemirror-state";

/**
 * Check if a mark (formatting like bold, italic, code) is active in the current selection
 *
 * Marks can be applied to:
 * - A text selection (when text is selected)
 * - The cursor position (stored marks, applied to the next character typed)
 *
 * @param state - The current editor state
 * @param type - The mark type to check (e.g., schema.marks.bold for bold)
 * @returns true if the mark is active in the current selection/cursor position
 */
export function markActive(state: EditorState, type: MarkType): boolean {
  const { from, $from, to, empty } = state.selection;
  // If selection is empty (just a cursor), check stored marks or marks at cursor position
  if (empty) return !!type.isInSet(state.storedMarks || $from.marks());
  // If text is selected, check if the mark exists anywhere in the selected range
  return state.doc.rangeHasMark(from, to, type);
}
